import React from 'react';
export function OfflineIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M13 15a1 1 0 11-2 0 1 1 0 012 0zm-2-9h2l-.5 6h-1L11 6z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.884 7.488A13.979 13.979 0 0112 2c4.53 0 8.559 2.153 11.116 5.488l.477.622L12.78 21.625h-1.562L.407 8.11l.477-.622zm2.08.616L12 19.399l9.036-11.295A11.97 11.97 0 0012 4a11.97 11.97 0 00-9.036 4.104z"
  }));
}